import { JsonObject, JsonProperty, JsonType, JsonValue } from "ta-json";

import type { MapCultureTo, MapStringTo, Nullable, Object_Unknown } from "../../base-types";
import { ComponentVisualization } from "./component-visualization";

@JsonObject()
export class PageComponentResource {
    @JsonProperty("id")
    id: number;

    @JsonProperty("identifier")
    identifier: string;

    @JsonProperty("name")
    name: string;

    @JsonProperty("type")
    type: string;

    @JsonProperty("title")
    title: MapCultureTo<string>;

    @JsonProperty("is_title_visible")
    isTitleVisible: boolean = false;

    @JsonProperty("is_visible")
    isVisible: boolean = false;

    @JsonProperty("is_nested")
    isNested: boolean = false;

    @JsonProperty("zone")
    zone: string;

    @JsonProperty("data")
    data: Object_Unknown;

    @JsonProperty("settings")
    settings: Object_Unknown;

    @JsonProperty("uiVisibility")
    uiVisibility: UIVisibility = "Always";

    @JsonProperty("messages")
    messages: MapStringTo<string>;

    @JsonProperty("visualization")
    visualization: ComponentVisualization;

    @JsonProperty("take_user_settings")
    takeUserSettings: boolean = false;

    @JsonProperty("use_react")
    useReact: Nullable<boolean>;

    @JsonProperty("conditions")
    @JsonType(Object)
    conditions?: Nullable<JsonValue>;
}

export type UIVisibility = "Always" | "OnlyEdit" | "OnlyRead";
